import React from 'react'

import {
  Breadcrumbs,
  ContentElements,
  ProductGrid,
  ProductListBanner,
  SubCategorySlider,
} from '../../patterns'

export default function GridLayout({
  banners,
  categoryId,
  productListProps,
  breadcrumbs,
  contentTop,
  contentBottom,
}) {
  return (
    <>
      {banners && (
        <ProductListBanner banners={banners} categoryId={categoryId} />
      )}
      <ContentElements elements={contentTop} />
      <Breadcrumbs items={breadcrumbs} />
      <SubCategorySlider
        key={categoryId}
        subCategories={productListProps.categoryData.subcategories_data}
      />

      <ProductGrid {...productListProps} />

      <ContentElements elements={contentBottom} />
    </>
  )
}
